export function useFormLayout()
{
    return {
        hideRequiredMark: true,
        colon: false,
        layout:"inline"
    }
}